import React, { useState } from 'react'
import { useForm, usePage } from '@inertiajs/inertia-react'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import PaginationList from '../../../Shared/Components/PaginationList'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import axios from 'axios'
import { SIA_NAVY } from '../../../constants/siaTheme'
import { HistoryModal, formatDate, formatTime } from './Index'

const CustomerServiceBitacora = ({
    entries,
    filters,
    advisers,
    statuses,
    canExport,
    canViewLog,
    canDeleteLog = false,
}) => {
    const { flash } = usePage().props
    const filterForm = useForm({
        search: filters.search || '',
        sia_customer_service_status_id: filters.sia_customer_service_status_id || '',
        adviser_id: filters.adviser_id || '',
    })
    const [history, setHistory] = useState({ show: false, logs: [], label: '' })

    const submitFilters = (e) => {
        e.preventDefault()
        filterForm.get(route('customer-service.bitacora.index'), { preserveState: true })
    }

    const openHistory = async (row) => {
        const { data } = await axios.get(route('customer-service.follow-up.history', row.sia_customer_service_record_id))
        setHistory({
            show: true,
            logs: data.logs || [],
            label: data.record_label || row.asegurado,
        })
    }

    const rows = entries.data || []

    return (
        <Row>
            {flash?.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath="admin/atencion-cliente/bitacora" />
            </span>

            <div
                className="rounded-2 mb-8 py-4 px-4 text-center text-white text-uppercase fw-bold fs-4"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.04em' }}
            >
                Bitácora de atención al cliente
            </div>

            <div className="card card-flush shadow-sm mb-8">
                <div className="card-body py-8 px-6">
                    <Form onSubmit={submitFilters} className="row g-4 align-items-end">
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Estado</Form.Label>
                            <Form.Select
                                className="form-select-solid"
                                value={filterForm.data.sia_customer_service_status_id}
                                onChange={(e) => filterForm.setData('sia_customer_service_status_id', e.target.value)}
                            >
                                <option value="">Todos</option>
                                {(statuses || []).map((s) => (
                                    <option key={s.id} value={s.id}>{s.name}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Asesor</Form.Label>
                            <Form.Select
                                className="form-select-solid"
                                value={filterForm.data.adviser_id}
                                onChange={(e) => filterForm.setData('adviser_id', e.target.value)}
                            >
                                <option value="">Todos</option>
                                {(advisers || []).map((a) => (
                                    <option key={a.id} value={a.id}>{a.display_name}</option>
                                ))}
                            </Form.Select>
                        </Col>
                        <Col md={3}>
                            <Form.Label className="fw-bold fs-7">Buscar</Form.Label>
                            <Form.Control
                                className="form-control-solid"
                                value={filterForm.data.search}
                                onChange={(e) => filterForm.setData('search', e.target.value)}
                                placeholder="Póliza, asegurado…"
                            />
                        </Col>
                        <Col md={3}>
                            <Button
                                type="submit"
                                disabled={filterForm.processing}
                                style={{ backgroundColor: SIA_NAVY, borderColor: SIA_NAVY }}
                            >
                                Filtrar
                            </Button>
                        </Col>
                    </Form>
                </div>
            </div>

            <div className="card card-flush shadow-sm">
                <div className="card-header border-0 pt-6 flex-wrap gap-3">
                    <h3 className="card-title fw-bold text-gray-800">Resultados</h3>
                    <div className="card-toolbar">
                        {canExport && (
                            <a className="btn btn-sm btn-light-primary" href={route('customer-service.bitacora.export', filterForm.data)}>
                                <i className="bi bi-file-earmark-excel me-1" />
                                Excel
                            </a>
                        )}
                    </div>
                </div>
                <div className="card-body pt-0">
                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-4">
                            <thead>
                                <tr className="fw-bold text-muted text-uppercase fs-7 bg-light">
                                    <th className="min-w-100px ps-4 rounded-start">Fecha</th>
                                    <th className="min-w-90px">Hora</th>
                                    <th className="min-w-120px">Registró</th>
                                    <th className="min-w-160px">Asegurado</th>
                                    <th className="min-w-110px">Póliza</th>
                                    <th className="min-w-140px">Trámite</th>
                                    <th className="min-w-110px">Estado</th>
                                    <th className="min-w-90px text-end pe-4 rounded-end">Historial</th>
                                </tr>
                            </thead>
                            <tbody className="fs-7">
                                {rows.length === 0 ? (
                                    <tr>
                                        <td colSpan={8} className="text-center text-muted py-10">
                                            No hay registros para los filtros seleccionados.
                                        </td>
                                    </tr>
                                ) : (
                                    rows.map((row) => (
                                        <tr key={row.id}>
                                            <td className="ps-4 text-gray-800">{formatDate(row.follow_up_date)}</td>
                                            <td className="text-gray-800">{formatTime(row.follow_up_time)}</td>
                                            <td className="text-gray-800">{row.contacted_by || '—'}</td>
                                            <td className="fw-semibold text-gray-800">{row.asegurado || '—'}</td>
                                            <td className="text-gray-800">{row.numero_poliza || '—'}</td>
                                            <td className="text-gray-700">{row.tramite || '—'}</td>
                                            <td className="text-gray-800">{row.status_name || '—'}</td>
                                            <td className="text-end pe-4">
                                                {canViewLog && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-icon btn-light-primary"
                                                        title="Ver historial"
                                                        onClick={() => openHistory(row)}
                                                    >
                                                        <i className="bi bi-list-ul" />
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex justify-content-center py-6">
                        <PaginationList links={entries.links} filters={filterForm.data} />
                    </div>
                </div>
            </div>

            <HistoryModal
                show={history.show}
                onHide={() => setHistory({ show: false, logs: [], label: '' })}
                logs={history.logs}
                recordLabel={history.label}
                canDeleteLog={canDeleteLog}
                onDeleted={(id) => setHistory((h) => ({ ...h, logs: h.logs.filter((l) => l.id !== id) }))}
            />
        </Row>
    )
}

CustomerServiceBitacora.layout = (page) => <Layout title="Bitácora atención al cliente">{page}</Layout>

export default CustomerServiceBitacora
